import { useQuery } from '@tanstack/react-query';
import { FileService, SolutionService } from '../services/validation.service';
import { validationKeys } from './keys';
export function useFiles() {
    return useQuery({
        queryKey: validationKeys.files(),
        queryFn: FileService.getFiles
    });
}
export function useFile(fileId) {
    return useQuery({
        queryKey: validationKeys.file(fileId || ''),
        queryFn: () => FileService.getFile(fileId),
        enabled: !!fileId
    });
}
export function useSolution(fileId, solutionId) {
    return useQuery({
        queryKey: validationKeys.solution(fileId || '', solutionId || ''),
        queryFn: () => SolutionService.get(fileId, solutionId),
        enabled: !!fileId && !!solutionId
    });
}
export function useSystemsConfig() {
    return useQuery({
        queryKey: validationKeys.config(),
        queryFn: FileService.getConfig,
        select: data => (data === null || data === void 0 ? void 0 : data.systems) || {}
    });
}
